


import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent
} from '@angular/common/http';

import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';


@Injectable()
export class GlobalInterceptor implements HttpInterceptor {       
  constructor(private injector: Injector) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent |HttpEvent<any>> {
    const re = 'api/';  
    const isSessionProbe = request.url.includes('oauth/check_token');
    const isAuthFlow = request.url.includes('oauth/token') || request.url.includes('/api/users/loginuser');
    let token=localStorage.getItem('token') || '';    
    if (request.url.search(re) === -1 ) {
        request = request.clone({
          setHeaders: {
           
            Authorization:  `Basic `+ btoa('clientIdPassword:secret')
          }
        });
    
    }else{
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer `+token
        }
      });
    }        

    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err.status === 401) {
          if (isSessionProbe || isAuthFlow) {
            return throwError(() => err);
          }

          const rememberedUsername = localStorage.getItem('username');
          localStorage.clear();
          if (rememberedUsername) {
            localStorage.setItem('username', rememberedUsername);
          }

          Swal.fire({
            icon: 'warning',
            title: 'Sesión expirada',
            text: 'Su sesión ha caducado, por favor inicie sesión nuevamente.',
            confirmButtonText: 'Ir al Login',
            allowOutsideClick: false
          }).then(() => {
            const router = this.injector.get(Router);
            router.navigate(['/login']);
          });
          // Se retorna EMPTY para que no dispare los catchError de cada servicio y no muestre la IP/URL
          return EMPTY;
        }

        // Sanitize error message to prevent URL/IP leakage on UI
        let safeErr = err;
        if (err && typeof err.message === 'string' && err.message.includes('Http failure response for')) {
          safeErr = new Error('Ocurrió un error interno en el servidor o el servicio no está disponible.');
          // Preserve any JSON error body properties used by components (err.error.mensaje, err.status, etc)
          safeErr.error = err.error;
          safeErr.status = err.status;
          safeErr.statusText = err.statusText;
        }

        return throwError(() => safeErr);
      })
    );
  }
}